import { consola } from 'consola'
import { ref, computed, onMounted, onUnmounted } from 'vue'

export const useSessionTimer = () => {
  const remainingSeconds = ref<number>(Infinity)
  const isExpiringSoon = ref(false)
  const isExpired = ref(false)
  let intervalId: ReturnType<typeof setInterval> | null = null

  const formatTime = (seconds: number): string => {
    if (seconds === Infinity) return '∞'
    const minutes = Math.floor(seconds / 60)
    const secs = Math.floor(seconds % 60)
    return `${minutes}:${secs.toString().padStart(2, '0')}`
  }

  const updateTimer = async () => {
    try {
      const { useSessionManager } = await import('@entities/auth')
      const remaining = useSessionManager().getTokenRemainingTime()
      remainingSeconds.value = remaining
      isExpired.value = remaining <= 0 && remaining !== Infinity
      isExpiringSoon.value = remaining > 0 && remaining <= 120
    } catch (error) {
      consola.error('[SessionTimer] update error:', error)
    }
  }

  const startTimer = () => {
    updateTimer()
    intervalId = setInterval(updateTimer, 1000)
  }
  const stopTimer = () => {
    if (intervalId) clearInterval(intervalId)
    intervalId = null
  }

  const formattedTime = computed(() => formatTime(remainingSeconds.value))
  const statusColor = computed(() => isExpired.value ? 'red' : isExpiringSoon.value ? 'orange' : 'green')
  const statusText = computed(() => {
    if (remainingSeconds.value === Infinity) return 'Не авторизован'
    if (isExpired.value) return 'Истекла'
    if (isExpiringSoon.value) return 'Истекает скоро'
    return 'Активна'
  })

  onMounted(startTimer)
  onUnmounted(stopTimer)

  return {
    remainingSeconds,
    formattedTime,
    isExpiringSoon,
    isExpired,
    statusColor,
    statusText,
    startTimer,
    stopTimer,
  }
}
